module.exports = __webpack_public_path__ + "img/Hatch-Sitemap.2ebd8312.png";